export const FETCH = 'FETCH';
export const POST = 'POST';
export const PUT = 'PUT';
export const DELETE = 'DELETE';

export const GET_LOCATION = 'GET_LOCATION';
export const GET_LOCATION_VIEW = 'GET_LOCATION_VIEW';
export const GET_TOUR = 'GET_TOUR';
export const GOT_RESPONSE = 'GOT_RESPONSE';
export const ERROR = 'ERROR';
/* data type methods */
export const ME = 'ME';
export const CLEAR_ME = 'CLEAR_ME';

export const GET_TOURS = 'GET_TOURS';
export const ADMIN_GET_TOURS = 'ADMIN_GET_TOURS';
export const ADMIN_GET_USERS = 'ADMIN_GET_USERS';
export const ADMIN_GET_TOURGUIDES = 'ADMIN_GET_TOURGUIDES';

/* tour crud options */
export const CREATE_TOUR = 'CREATE_TOUR';
export const GET_MYTOUR = 'GET_MYTOUR';
export const EDIT_TOUR = 'EDIT_TOUR';
export const DELETE_TOUR = 'DELETE_TOUR';
export const CLEAR_MYTOUR = 'CLEAR_MYTOUR';

/* tour events (scheduling) */
export const GET_TOUR_EVENTS = 'GET_TOUR_EVENTS';
export const CREATE_TOUR_EVENT = 'CREATE_TOUR_EVENT';
export const DELETE_TOUR_EVENT = 'DELETE_TOUR_EVENT';

/* public tour events and booking */
export const GET_PUBLIC_TOUR_EVENTS = 'GET_PUBLIC_TOUR_EVENTS';
export const CREATE_BOOKING = 'CREATE_BOOKING';
export const CLEAR_PUBLIC_TOUR_EVENTS = 'CLEAR_PUBLIC_TOUR_EVENTS';

/* search */
export const SEARCH_TOURS = 'SEARCH_TOURS';
export const CLEAR_SEARCH_RESULTS = 'CLEAR_SEARCH_RESULTS';

export const GET_LOCATIONS = 'GET_LOCATIONS';

export const EDIT_TOURGUIDE = 'EDIT_TOURGUIDE';
export const LOCAL_EDIT_TOURGUIDE = 'LOCAL_EDIT_TOURGUIDE'; // used when we change the tourguide locally. 
export const CREATE_TOURGUIDE = 'CREATE_TOURGUIDE';
export const GET_MY_TOURGUIDE_PROFILE = 'GET_MY_TOURGUIDE_PROFILE';
export const GET_PRESIGNED_IMAGE_URLS = 'GET_PRESIGNED_IMAGE_URLS';
export const CLEAR_PRESIGNED_IMAGE_URLS = 'CLEAR_PRESIGNED_IMAGE_URLS'; // after we create the images

export const UPLOAD_FILE_TO_S3 = 'UPLOAD_FILE_TO_S3';

/* Audio track management */
export const GET_TOUR_TRACKS = 'GET_TOUR_TRACKS';
export const CREATE_AUDIO_TRACK = 'CREATE_AUDIO_TRACK';
export const UPDATE_AUDIO_TRACK = 'UPDATE_AUDIO_TRACK';
export const DELETE_AUDIO_TRACK = 'DELETE_AUDIO_TRACK';
export const GET_AUDIO_PRESIGNED_URL = 'GET_AUDIO_PRESIGNED_URL';
export const CLEAR_AUDIO_PRESIGNED_URL = 'CLEAR_AUDIO_PRESIGNED_URL';

/* Tour sharing */
export const GET_TOUR_SHARES = 'GET_TOUR_SHARES';
export const CREATE_TOUR_SHARE = 'CREATE_TOUR_SHARE';
export const DELETE_TOUR_SHARE = 'DELETE_TOUR_SHARE';
export const CLEAR_TOUR_SHARES = 'CLEAR_TOUR_SHARES';